import Controls from "../../Components/Controls/Controls";
import EventsList from "../../Components/EventsList/EventsList";

const MainPage = () => {
    return (
        <div>
            <Controls/>
            <EventsList/>
        </div>
    )
};

export default MainPage;